import { Alert } from '@mui/material';
import { useMemo } from 'react';
import { PENDING_PROMO_CODE_INFO } from '../../app/constants';
import { getPendingPromoCode } from '../../app/utils';

const PendingPromoAlert = ({ message }: { message?: string }) => {
  const pendingPromo = useMemo(() => getPendingPromoCode(), []);

  if (!pendingPromo) return null;

  return (
    <Alert severity="info" sx={{ mb: 2, fontSize: 14, textAlign: 'left' }}>
      Promo code <strong>{pendingPromo}</strong> {message ?? PENDING_PROMO_CODE_INFO}
    </Alert>
  );
};

export default PendingPromoAlert;
